var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxtf-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        width: "850px",
        cutline: false,
        "show-close": false,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "destroy-on-close": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.init,
      },
    },
    [
      _c("div", { staticClass: "medal-content" }, [
        _c("div", { ref: "container", staticClass: "medal-content-bgimg" }),
        _vm.dialogVisible
          ? _c(
              "div",
              { staticClass: "medal-content-container" },
              [
                _c("div", { staticClass: "medal-desc" }, [
                  _vm._v(_vm._s(_vm.medalCountStr)),
                ]),
                _c(
                  "yxtf-image",
                  {
                    staticClass: "medal-icon",
                    staticStyle: { width: "200px", height: "200px" },
                    attrs: { src: _vm.currentMedal.icon, fit: "contain" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "image-slot",
                        attrs: { slot: "placeholder" },
                        slot: "placeholder",
                      },
                      [_vm._v("\n        loading...\n      ")]
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.medalList.length > 1 && _vm.currentIndex > 0
          ? _c(
              "div",
              {
                staticClass: "medal-content-arrow_left",
                on: { click: _vm.moveLeft },
              },
              [
                _c("yxtf-svg", {
                  attrs: {
                    width: "24px",
                    height: "24px",
                    "icon-class": "arrow_left",
                    "remote-url": _vm.mediaPath,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.medalList.length > 1 && _vm.currentIndex < _vm.medalList.length - 1
          ? _c(
              "div",
              {
                staticClass: "medal-content-arrow_right",
                on: { click: _vm.moveRight },
              },
              [
                _c("yxtf-svg", {
                  attrs: {
                    width: "24px",
                    height: "24px",
                    "icon-class": "arrow_right",
                    "remote-url": _vm.mediaPath,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "medal-content-bottom" },
        [
          _c("div", { staticClass: "medal-name" }, [
            _vm._v(_vm._s(_vm.currentMedal.title)),
          ]),
          _c(
            "yxtf-button",
            {
              staticClass: "medal-btn",
              attrs: { size: "other", type: "primary" },
              on: { click: _vm.close },
            },
            [_vm._v(_vm._s(_vm.currentMedal.btnName))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }